module.exports = __webpack_public_path__ + "img/idCard.7ee3651b.png";